<script setup lang="ts">
import { useSpyStore } from '@/stores/spyStore.ts'
import SpyDetails from '@/components/Sections/Diplomacy/Spies/SpyDetails.vue'
import { computed } from 'vue'
import StandardCard from '@/components/Elements/Cards/StandardCard.vue'
import { useGameStore } from '@/stores/gameStore.ts'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const spyStore = useSpyStore()
const gameStore = useGameStore()

// Convert Map values to an array and sort by level (highest first), then by killed status
const sortedSpies = computed(() =>
  Array.from(spyStore.spies.values()).sort((a, b) => {
    // First, separate alive and dead spies
    if (a.killed !== b.killed) {
      return a.killed - b.killed // alive spies (killed=0) come first
    }
    
    // For alive spies, sort by level (highest first)
    if (a.killed === 0 && b.killed === 0) {
      return b.level - a.level // descending order (highest level first)
    }
    
    // For dead spies, also sort by level (highest first)
    return b.level - a.level
  })
)
</script>

<template>
  <StandardCard :title="t('diplomacy.spies.title')" class="w-full xl:w-2/3 mx-auto pt-1 px-2 md:px-0">
    {{ t('diplomacy.spies.description') }}
    <span v-if="gameStore.combatMode === 'RC'" class="text-red-500">
      {{ t('diplomacy.spies.warningRC') }}
    </span>
  </StandardCard>
  <div class="grid md:grid-cols-5 grid-cols-2 sm:grid-cols-3 gap-2 w-full xl:w-2/3 mx-auto pt-2 px-2 md:px-0">
    <template v-for="spy in sortedSpies" :key="spy.id">
      <SpyDetails :spy="spy" icon="spy"/>
    </template>
  </div>
</template>

<style scoped lang="scss">
</style>
